import { render, staticRenderFns } from "./FormattedNumberComponent.vue?vue&type=template&id=26276e31&"
import script from "./FormattedNumberComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedNumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports